/**
 * Utility functions for the live view tab and components.
 */

import {getUnitID, getUnitLiveStreamStatus, getUnitLiveStreamURL} from "../utils";
import {dbase} from '../../../firebase';

const MY_STREAM_STRING = 'myStream';

const MESSAGE_INVALID_STREAM = "INVALID_LIVE_STREAM";

export const STATUS_LIVE_STREAM_START = "start";
export const STATUS_LIVE_STREAM_RECORDING = "recording";
export const STATUS_LIVE_STREAM_READY = "ready";

/**
 * Returns {@code true} if {@param unit}
 * is start. Should not trigger.
 */
export const isStarting = (unit) => (getUnitLiveStreamStatus(unit) === STATUS_LIVE_STREAM_START);

/**
 * Starts {@param unit}'s recording state
 * by setting the firebase status to start.
 */
export const startRecording = (unit) => {
    dbase.setLiveStreamStart(getUnitID(unit));
    return true;
};

/**
 * Returns {@code true} if {@param unit}
 * is currently recording a video
 */
export const isRecording = (unit) => (getUnitLiveStreamStatus(unit) === STATUS_LIVE_STREAM_RECORDING);

/**
 * Returns {@code true} if {@param unit}
 * is ready to render recorded video
 */
export const isReady = (unit) => (getUnitLiveStreamStatus(unit) === STATUS_LIVE_STREAM_READY && !!getUnitLiveStreamURL(unit));

/**
 * Takes a raw
 * @param wowzaInfoRaw URL and a
 * @param UUID of the AutoI unit
 * and
 * @returns string formatted URL which can be used for live streaming to the client.
 */
export const getFormattedLiveStream = (wowzaInfoRaw, UUID) => {
    if (wowzaInfoRaw && UUID) {
        return wowzaInfoRaw.replace(MY_STREAM_STRING, UUID);
    } else {
        return MESSAGE_INVALID_STREAM;
    }
};



// WEBPACK FOOTER //
// ./src/components/unit/liveview/utils.js